// extracted by mini-css-extract-plugin
export default {"button":"Button-module--button--ECaJB","standard":"Button-module--standard--vHQW0","disabled":"Button-module--disabled--ap97x","busy":"Button-module--busy--h3pg1"};